import { useState } from 'react';

/**
 * Hook to manage contact selection state and actions
 * Handles individual contact selection and select-all functionality
 */
export const useContactSelection = (contactsArray) => {
	const [selectedContacts, setSelectedContacts] = useState([]);

	/**
	 * Toggle selection of a single contact
	 */
	const handleContactToggle = (contactId) => {
		setSelectedContacts((prev) =>
			prev.includes(contactId) ? prev.filter((id) => id !== contactId) : [...prev, contactId],
		);
	};

	/**
	 * Toggle selection of all contacts
	 * If all are selected, deselect all. Otherwise, select all.
	 */
	const handleSelectAllContacts = () => {
		const allContactIds = contactsArray.map((c) => c.id);
		setSelectedContacts((prev) => (prev.length === allContactIds.length ? [] : allContactIds));
	};

	/**
	 * Clear all selections (no contacts selected after)
	 */
	const clearSelection = () => {
		setSelectedContacts([]);
	};

	/**
	 * Check if all contacts are selected
	 */
	const allContactsSelected = selectedContacts.length > 0 && selectedContacts.length === contactsArray.length;

	return {
		selectedContacts,
		setSelectedContacts,
		handleContactToggle,
		handleSelectAllContacts,
		clearSelection,
		allContactsSelected,
	};
};
